export const TIERS = {
  FREE: 'free',
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
};

export const TIER_ORDER = ['free', 'small', 'medium', 'large'];

export const TIER_DISPLAY_NAMES = {
  free: 'Free',
  small: 'MasterChart Basic',
  medium: 'MasterChart',
  large: 'MasterChart Enhanced',
};

/**
 * Returns true if userTier >= requiredTier in the tier ordering.
 * Unknown tiers are treated as below free.
 */
export function tierAtLeast(userTier, requiredTier) {
  const userIdx = TIER_ORDER.indexOf(userTier);
  const reqIdx = TIER_ORDER.indexOf(requiredTier);
  if (userIdx === -1 || reqIdx === -1) return false;
  return userIdx >= reqIdx;
}

// LOTSOG-specific tier strings — separate from main subscription tiers
export const LOTSOG_TIER_ORDER = ["scout", "fellow", "scholar", "luminary"];

export const LOTSOG_TIERS = {
  SCOUT: "scout",
  FELLOW: "fellow",
  SCHOLAR: "scholar",
  LUMINARY: "luminary",
};

/**
 * Returns true if userLotsogTier >= requiredTier in LOTSOG tier ordering.
 * Unknown tiers treated as below scout (false).
 */
export function lotsogTierAtLeast(userTier, requiredTier) {
  const userIdx = LOTSOG_TIER_ORDER.indexOf(userTier);
  const reqIdx = LOTSOG_TIER_ORDER.indexOf(requiredTier);
  if (userIdx === -1 || reqIdx === -1) return false;
  return userIdx >= reqIdx;
}

/**
 * Returns true if the user can contribute to LOTSOG discussions.
 * Any paid LOTSOG tier (fellow and above) can contribute.
 */
export function canContributeToDiscussion(lotsogTier) {
  return lotsogTierAtLeast(lotsogTier, LOTSOG_TIERS.FELLOW);
}

/**
 * Firestore user row from phone dev-auth (codes in apps/unified-app devAuthCodes.js).
 * Treat as dev for client tier bypass even if `isDevAccount` is missing (legacy docs) or non-boolean.
 * All synthetic dev-auth emails in that config use `@dev.local`.
 *
 * @param {Record<string, unknown> | null | undefined} userData
 * @returns {boolean}
 */
export function isDevAuthFirestoreUser(userData) {
  if (!userData || typeof userData !== "object") return false;
  if (userData.isDevAccount === true) return true;
  if (userData.isDevAccount === "true") return true;
  const devAuthCode = userData.devAuthCode;
  if (devAuthCode != null && String(devAuthCode).trim() !== "") return true;
  const email = userData.email;
  return (
    typeof email === "string" && email.toLowerCase().endsWith("@dev.local")
  );
}
